import { ReactElement } from 'react';
import { PersonInfo, PersonStyle } from './styles';
import { OrderDetailsI } from '@app/healthcheck/order/types';
import { ButtonsContainer, StyledHeaderLarge } from './styles';
import ActionButtons from './actionButtons/actions';
import StatusLabel from './statusLabel';
import { applyEllipsis } from '@app/utils';

interface PersonProps {
  handleAddResultsOpen: () => void;
  handleTestPerformed: () => void;
  handleOrderConfirmed: () => void;
  data: OrderDetailsI;
  handleDeleteOrderOpen: () => void;
  handlePreviousStageOrderOpen: () => void;
  handleResendCertificate: () => void;
  handleGenerateCertificate: () => void;
  showPreviousStageAndGenerateCertificateButtons: boolean;
}

const Person = ({
  data,
  handleTestPerformed,
  handleOrderConfirmed,
  handleAddResultsOpen,
  handleDeleteOrderOpen,
  handlePreviousStageOrderOpen,
  handleResendCertificate,
  handleGenerateCertificate,
  showPreviousStageAndGenerateCertificateButtons,
}: PersonProps): ReactElement => {
  const handlers = {
    handleTestPerformed,
    handleOrderConfirmed,
    handleAddResultsOpen,
    handleDeleteOrderOpen,
    handlePreviousStageOrderOpen,
    handleResendCertificate,
    handleGenerateCertificate,
  };

  return (
    <PersonStyle>
      <PersonInfo>
        <StyledHeaderLarge data-testid="healthcheck-order-details-header">
          {applyEllipsis(`${data.firstName} ${data.lastName}`, 20)}
        </StyledHeaderLarge>
        <StatusLabel
          status={data.status}
          timerEnd={data.timerEnd}
          result={data.result}
        />
      </PersonInfo>
      <ButtonsContainer>
        <ActionButtons
          isResendCertificate={data.isResendCertificate}
          isCertificateGenerated={data.isCertificateGenerated}
          handlers={handlers}
          state={data.status}
          testType={data.testType}
          showPreviousStageAndGenerateCertificateButtons={
            showPreviousStageAndGenerateCertificateButtons
          }
        />
      </ButtonsContainer>
    </PersonStyle>
  );
};

export default Person;
